"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shuffle = exports.compareExtract = exports.compareReverse = exports.compareNature = void 0;

var compareNature = function compareNature() {
  return function (l, r) {
    return l < r ? -1 : l === r ? 0 : 1;
  };
};

exports.compareNature = compareNature;

var compareReverse = function compareReverse() {
  var compare = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : compareNature();
  return function (e1, e2) {
    return compare(e2, e1);
  };
};

exports.compareReverse = compareReverse;

var compareExtract = function compareExtract(mapper) {
  var compare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : compareNature();
  return function (target1, target2) {
    return compare(mapper(target1), mapper(target2));
  };
};

exports.compareExtract = compareExtract;

var shuffle = function shuffle(elements) {
  var wrapper = elements.map(function (element) {
    return {
      element: element,
      weight: Math.random()
    };
  });
  wrapper.sort(compareExtract(function (_ref) {
    var weight = _ref.weight;
    return weight;
  }));
  return wrapper.map(function (_ref2) {
    var element = _ref2.element;
    return element;
  });
};

exports.shuffle = shuffle;